import React from 'react';
import { Link } from 'react-router-dom';
import './aside.css'

const AsideTopic = (props) => {
    const {name,id} = props.sd
    console.log(name);
    return (
        <div className='ps-4'>
            <Link className=' fw-semibold fs-5 text-primary text-decoration-none ps-5 pt-1 ' to={`/courses/${id}`}>
            <p className='aside-name'>{name}</p></Link>
        </div>
    );
};

export default AsideTopic;